import { useApplicationState } from "./useApplicationState";

export const useApplicationType = () => {
  const application_store = useApplicationState(s => s.application_store);
  return application_store(s => s.application);
}